/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { useAuthData } from '../context/AuthProvider'
import { useThemeData } from '../context/ThemeDataContext'

const AppRoutes = ({
  component:
    Component,
  path,
  exact,
  isPrivate,
  folder_id,
  user_id,
  product_color,
  keuzeset_id,
  category_id,
  session_id,
  location,
  ...rest
}) => {
  const { auth } = useAuthData()
  const { photographerType } = useThemeData()
  
  return (
    <Route
      exact={exact}
      path={path}
      render={(props) =>
        isPrivate && auth === false && photographerType === 'schoolfotos' ? (
            <Redirect to={{ pathname: '/login' }}/>
          ) :
          isPrivate && photographerType === 'printservice' ? (
              <Redirect to={{ pathname: '/' }}/>
            ) :
            (
                // <></>
              <Component
                {...props}
                folder_id={folder_id}
                session_id={session_id}
                user_id={user_id}
                keuzeset_id={keuzeset_id}
                category_id={category_id}
                product_color={product_color}
                location={location}
              />
            )
      }
      {...rest}
    />
  )
}

export default AppRoutes
